import { Empty } from "antd"

/**
 * @param {*} props 
 * @param {String} props.message message to be shown like `NO DATA`
 * @param {React.ReactNode} props.image pass any ReactNode to display a custom image
 * @returns {React.ReactNode} returns a react node to display a message of Empty data
 * 
 */

export default function EmptyData(props) {
  return <Empty description={props.message} image={props.image || Empty.PRESENTED_IMAGE_SIMPLE} />
}
